/*
 * Ryan O'Dowd
 * 2025-07-18
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import Button from '@components/common/Button';
import Icon from '@react-native-vector-icons/material-design-icons';
import NewSchoolDialog from '@website/components/NewSchoolDialog';
import getStyles from './styles';
import hooks from '@hooks';

const StartTrialButton = () => {
  const styles = hooks.useStyles(getStyles);

  const [_isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <React.Fragment>
      <Button
        style={styles.actionButton}
        contentStyle={styles.actionButtonText}
        theme={styles.colors.accent}
        onPress={() => {
          // @TODO: open dialog for stripe checkout
          setIsDialogOpen(true);
          // @TODO: dialog should have info about payment options (cheaper if via check or ach)
          // @TODO: also info about estimating the number of students now and being charged additional in arrears (discount for upfront payment)
          // @TODO: info about < 10 students free, or cancel before trial expires
          /* @TODO: ideas:
           * - free over the summer (or maybe prorated per-student pricing between January and June?)...actually i like prorated if registering between January and June, free over summer)...all contracts go august 1 through july 31
           * - need flexible option? like auto add students when they join the classroom, or should there be a dashboard with paid seats?
           * - consider homeschoolers...maybe they still sign up the same way as schools
            •	Offer credit card or ACH for smaller schools (or if under $1,000).
            •	require purchase order / manual invoicing for larger schools (common in K–12).
            -talk to jared/ronald/joe about what this looks like in practice (ask who handles most of these and take that person out to lunch)
            •	Optional: Allow them to commit to multi-year for a discount (e.g. 2 years = 10% off). (how does this affect prorated amounts?)
           */
        }}
        icon={() => <Icon name='cart' size={styles.globalScale * 20} color={styles.colors.primaryExtraDark} />}// @TODO: better icon
      >
        Start trial
      </Button>

      <NewSchoolDialog
        isOpen={_isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />

    </React.Fragment>
  );
};

export default StartTrialButton;
